import { __decorate, __extends } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
var SunRating = /** @class */ (function (_super) {
    __extends(SunRating, _super);
    function SunRating() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SunRating.prototype.data = function () {
        return {
            ratingList: [],
            hash: 0
        };
    };
    SunRating.prototype.getRatings = function () {
        var maxRate = Math.floor(this.rating);
        var ratingMaxRate = this.rating % maxRate;
        var rateResidual = ratingMaxRate.toFixed(1);
        for (var index = 0; index < 6; index++) {
            if (index < maxRate) {
                this.ratingList[index] = '1';
            }
            else if (index < this.rating) {
                this.ratingList[index] = rateResidual;
            }
            else {
                this.ratingList[index] = '0';
            }
        }
        this.$forceUpdate();
    };
    SunRating.prototype.setId = function (id) {
        return 'url(#' + id + ')';
    };
    SunRating.prototype.mounted = function () {
        this.getRatings();
        this.hash = Math.random();
    };
    __decorate([
        Prop()
    ], SunRating.prototype, "rating", void 0);
    __decorate([
        Prop()
    ], SunRating.prototype, "width", void 0);
    __decorate([
        Prop()
    ], SunRating.prototype, "height", void 0);
    __decorate([
        Prop()
    ], SunRating.prototype, "noRating", void 0);
    SunRating = __decorate([
        Component
    ], SunRating);
    return SunRating;
}(Vue));
export default SunRating;
